import React, { useState, useEffect, } from 'react';
import './style.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

function SocialMedia(props) {
    const [twitter, setTwitter] = useState('');
    const [facebook, setFacebook] = useState('');
    const [instagram, setInstagram] = useState('');

    useEffect(() => {
        props.twitter !== undefined ? setTwitter(`${props.twitter}`) : setTwitter(``)
        props.facebook !== undefined ? setFacebook(`${props.facebook}`) : setFacebook(``)
        props.instagram !== undefined ? setInstagram(`${props.instagram}`) : setInstagram(``)
    }, [props])
    
    const socialLinksHandler = (event) => {
        console.log("socialLinksHandler",event.target.value);
        if (event.target.id === "twitter") {
            setTwitter(event.target.value)
            let valCurr = {
                status: 1,
                value: event.target.value
            }
            props.changedSocialLinks(valCurr);
        }
        else if (event.target.id === "facebook") {
            setFacebook(event.target.value)
            let valCurr = {
                status: 2,
                value: event.target.value
            }
            props.changedSocialLinks(valCurr);
        }
        else if (event.target.id === "instagram") {
            setInstagram(event.target.value)
            let valCurr = {
                status: 3,
                value: event.target.value
            }
            props.changedSocialLinks(valCurr);
        }
    }


    return (
        <div className="container pad-bot20">
            <Row >
                <Col lg={12} className="coverphoto pad0">
                    <div >
                        <div className="pad-tb30 cover-border">
                            <h3>{props.mediaHeading}</h3>
                            <p>{props.mediaSubHead}</p>
                        </div>
                    </div>
                    <div className="pad-tb30">
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg="12" controlId="twitter">
                                    <Form.Label className="pad-r5">Twitter</Form.Label>
                                    <InputGroup className="mb-3">
                                        <InputGroup.Prepend>
                                        <InputGroup.Text id="basic-addon3">
                                            https://twitter.com/
                                        </InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control 
                                        //required
                                        type="text"
                                        value={twitter}
                                        //defaultValue={twitter}
                                        placeholder="pechakucha_org"
                                        onChange={socialLinksHandler} />
                                    </InputGroup>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} lg="12" controlId="facebook">
                                    <Form.Label className="pad-r5">Facebook</Form.Label>
                                    <InputGroup className="mb-3">
                                        <InputGroup.Prepend>
                                        <InputGroup.Text id="basic-addon3">
                                            https://facebook.com/
                                        </InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control 
                                        //required
                                        type="text"
                                        value={facebook}
                                        //defaultValue={facebook}
                                        placeholder="pechakucha_org"
                                        onChange={socialLinksHandler} />
                                    </InputGroup>
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} lg="12" controlId="instagram">
                                    <Form.Label className="pad-r5">Instagram</Form.Label>
                                    <InputGroup className="mb-3">
                                        <InputGroup.Prepend>
                                        <InputGroup.Text id="basic-addon3">
                                            https://instagram.com/
                                        </InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control 
                                        //required
                                        type="text"
                                        value={instagram}
                                        //defaultValue={instagram}
                                        placeholder="pechakucha_org"
                                        onChange={socialLinksHandler} />
                                    </InputGroup>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default SocialMedia;